import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import Error from './pages/Error';
/*import TagManager from 'react-gtm-module'*/

/*const tagManagerArgs = { gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID || '' }*/

/*TagManager.initialize(tagManagerArgs)*/

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ErrorBoundary fallback={<Error
                errorTitle="Error"
                errorMessage="Unknown error occured while processing your request." />}>
                <App />
            </ErrorBoundary>
        </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
